
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import { AddwithWhiteCircle, DropdownArrow, SearchBig, UpdatePencil, PDFIcon, AddwithBlueCircle, UploadIcon } from "../AllSvg";
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import { ViewEmployeeList, ViewTeamLead } from "../CustomFunctions";
import { handleErrorToast } from "../CustomFunctions";
import { toast, ToastContainer } from 'react-toastify';

import Dashboardnavbar from '../../layout/Dashboardnavbar';

import TableDesignssubcompany from './Tabledesignssettings';
import Structureheadingmain from "../Structureheading/Tablestructureheading"
import TableReview from "../ReviewTeam/TableReview";



const AddDepartmentAndActivity = ({ getDevisionName }) => {
    // const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        division_code: "",
        division_name: "",
        activity: [],   // this will hold the list
    });

    const [activityInput, setActivityInput] = useState(""); // just for the input field

    // handle text input
    const handleActivityInputChange = (e) => {
        setActivityInput(e.target.value);
    };

    // add activity to the list
    const handleAddActivity = () => {
        const value = activityInput.trim();
        if (!value) return;

        if (!formData.activity.includes(value)) {
            setFormData((prev) => ({
                ...prev,
                activity: [...prev.activity, value],
            }));
        }
        setActivityInput(""); // clear input
    };

    // remove an activity
    const handleRemoveActivity = (index) => {
        setFormData((prev) => ({
            ...prev,
            activity: prev.activity.filter((_, i) => i !== index),
        }));
    };

    const handleShow = () => {
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    };
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [activities, setActivities] = useState([]);

    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;

        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }

        console.log(newValue);
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));
        let errorMessage = "";

        if (errorMessage) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: errorMessage,
            }));
            return;
        } else {
            setErrors((prevErrors) => {
                const { [name]: removedError, ...rest } = prevErrors;
                return rest;
            });
        }

        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    // const handleAddActivity = () => {
    //     if (!formData.activity?.trim()) return;
    //     if (!activities.includes(formData.activity?.trim())) {
    //         setActivities([...activities, formData.activity?.trim()]);
    //     }
    //     setFormData({ ...formData, activity: [] });
    // };

    // const handleRemoveActivity = (index) => {
    //     setActivities(activities.filter((_, i) => i !== index));
    // };



    // const handleFormSubmit = async (e) => {
    //     e.preventDefault();
    //     const newerror = {};


    //     if (Object.keys(newerror).length === 0) {
    //         const loadingToastId = toast.loading("Loading: Please wait...");
    //         try {

    //             let res = await axios.post(
    //                 `${BASE_URL}/detail-design/division/`,{ ...formData, activities },
    //                 {
    //                     headers: {
    //                         "Content-Type": "multipart/form-data",
    //                     },
    //                 }
    //             );

    //             if (res.status === 200) {
    //                 setShow(false);
    //                 setFormData(() => Object.keys(formData).reduce((acc, key) => {
    //                     acc[key] = '';
    //                     return acc;
    //                 }, {}));
    //                 await getDevisionName();
    //             } else {
    //             }
    //         } catch (err) {
    //             //toast Logic
    //             handleErrorToast(err);
    //         } finally {
    //             // setLoading(false); //loading logic
    //             toast.dismiss(loadingToastId);
    //         }
    //     }
    // };


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const newerror = {};

        if (Object.keys(newerror).length === 0) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                let res = await axios.post(
                    `${BASE_URL}/detail-design/division/`,
                    {
                        ...formData,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    await getDevisionName();
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                title="Add Division"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Devision
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Add Division</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form">
                        <div className="form-flex-wrap">

                            <div title="Department Name" className="flex-column">
                                <label
                                    htmlFor="Department Name"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Division Name
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="division_name"
                                    name="division_name"
                                    placeholder="Division Name"
                                    onChange={handleInputChange}
                                    value={formData.division_name}
                                    className={`form-input ${errors.division_name ? "error" : inputState.division_name ? "success" : ""
                                        }`}
                                />
                                {errors.division_name && (
                                    <span className="error-message font-size-text ">
                                        {errors.division_name}
                                    </span>
                                )}
                            </div>

                            <div title="Department Code" className="flex-column">
                                <label
                                    htmlFor="company_name"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Division Code
                                </label>
                                <input
                                    type="text"
                                    maxLength={100}
                                    id="division_code"
                                    name="division_code"
                                    placeholder="Division Code"
                                    onChange={handleInputChange}
                                    value={formData.division_code}
                                    className={`form-input ${errors.division_code
                                        ? "error"
                                        : inputState.division_code
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.division_code && (
                                    <span className="error-message font-size-text ">
                                        {errors.division_code}
                                    </span>
                                )}
                            </div>

                            <div title="Activity" className="flex-column">
                                <label
                                    htmlFor="activity"
                                    className="form-labels font-weight500 font-size-subheading"
                                >
                                    Activity:
                                </label>

                                {/* Input + Add Button (row layout) */}
                                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                    <input
                                        type="text"
                                        value={activityInput}
                                        onChange={handleActivityInputChange}
                                        placeholder="Enter activity"
                                        className="form-inputs-01"
                                    />
                                    <button className="form-inputs-submit01" type="button" onClick={handleAddActivity}>
                                        Add
                                    </button>
                                </div>

                                {/* Activities List (below input) */}
                                <ul style={{ display: "flex", gap: "10px", listStyle: "none", padding: 0, margin: "10px 0" }}>
                                    {(Array.isArray(formData.activity) ? formData.activity : []).map((act, idx) => (
                                        <li
                                            key={idx}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                padding: "6px 10px",
                                                background: "#f1f1f1",
                                                borderRadius: "8px"
                                            }}
                                        >
                                            {act}
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveActivity(idx)}
                                                style={{ border: "none", background: "transparent", cursor: "pointer" }}
                                            >
                                                ❌
                                            </button>
                                        </li>
                                    ))}
                                </ul>


                                {/* Error Message */}
                                {errors.activity && (
                                    <span className="error-message font-size-text">
                                        {errors.activity}
                                    </span>
                                )}
                            </div>



                            <div className="button-models" style={{ width: "100%" }}>
                                <button
                                    onClick={handleFormSubmit}
                                    className="model-button   font-weight500    model-button-submit">
                                    {/* //loading logic */}
                                    Add
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};


const UpdateDepartmentAndActivity = ({ getDevisionName, divisionData = null }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        id: "",
        division_code: "",
        division_name: "",
        activity: [],
    });

    const [activityInput, setActivityInput] = useState("");
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    // Pre-fill form if editing
    useEffect(() => {
        if (divisionData) {
            setFormData({
                id: divisionData.id,
                division_code: divisionData.division_code || "",
                division_name: divisionData.division_name || "",
                activity: divisionData.activity || [],
            });
        }
    }, [divisionData]);

    const handleShow = () => setShow(true);

    const handleClose = () => {
        setShow(false);
        if (!divisionData) {
            setFormData({
                id: "",
                division_code: "",
                division_name: "",
                activity: [],
            });
        }
    };

    // text input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState((prev) => ({
            ...prev,
            [name]: value.trim() ? "green" : "",
        }));

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (value.trim()) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    // activity input change
    const handleActivityInputChange = (e) => setActivityInput(e.target.value);

    const handleAddActivity = () => {
        const value = activityInput.trim();
        if (!value) return;
        if (!formData.activity.includes(value)) {
            setFormData((prev) => ({
                ...prev,
                activity: [...prev.activity, value],
            }));
        }
        setActivityInput("");
    };

    const handleRemoveActivity = (index) => {
        setFormData((prev) => ({
            ...prev,
            activity: prev.activity.filter((_, i) => i !== index),
        }));
    };

    // submit
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Saving...");

        try {
            let res;
            if (formData.id) {
                // update mode
                res = await axios.put(
                    `${BASE_URL}/detail-design/division/${formData.id}/`,
                    formData,
                    { headers: { "Content-Type": "application/json" } }
                );
            } else {
                // create mode
                res = await axios.post(
                    `${BASE_URL}/detail-design/division/`,
                    formData,
                    { headers: { "Content-Type": "application/json" } }
                );
            }

            if (res.status === 200 || res.status === 201) {
                setShow(false);
                await getDevisionName();
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button onClick={handleShow} className="model-edit-button">
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>
                        {formData.id ? "Update Division" : "Add Division"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="register-form">
                        <div className="form-flex-wrap">
                            {/* Division Code */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Division Code
                                </label>
                                <input
                                    type="text"
                                    id="division_code"
                                    name="division_code"
                                    placeholder="Division Code"
                                    onChange={handleInputChange}
                                    value={formData.division_code}
                                    className={`form-input ${
                                        errors.division_code
                                            ? "error"
                                            : inputState.division_code
                                            ? "success"
                                            : ""
                                    }`}
                                />
                                {errors.division_code && (
                                    <span className="error-message font-size-text">
                                        {errors.division_code}
                                    </span>
                                )}
                            </div>

                            {/* Division Name */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Division Name
                                </label>
                                <input
                                    type="text"
                                    id="division_name"
                                    name="division_name"
                                    placeholder="Division Name"
                                    onChange={handleInputChange}
                                    value={formData.division_name}
                                    className={`form-input ${
                                        errors.division_name
                                            ? "error"
                                            : inputState.division_name
                                            ? "success"
                                            : ""
                                    }`}
                                />
                                {errors.division_name && (
                                    <span className="error-message font-size-text">
                                        {errors.division_name}
                                    </span>
                                )}
                            </div>

                            {/* Activity */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Activity
                                </label>
                                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                    <input
                                        type="text"
                                        value={activityInput}
                                        onChange={handleActivityInputChange}
                                        placeholder="Enter activity"
                                        className="form-inputs-01"
                                    />
                                    <button
                                        className="form-inputs-submit01"
                                        type="button"
                                        onClick={handleAddActivity}
                                    >
                                        Add
                                    </button>
                                </div>
                                <ul
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        listStyle: "none",
                                        padding: 0,
                                        margin: "10px 0",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {(Array.isArray(formData.activity)
                                        ? formData.activity
                                        : []
                                    ).map((act, idx) => (
                                        <li
                                            key={idx}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                padding: "6px 10px",
                                                background: "#f1f1f1",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            {act}
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveActivity(idx)}
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ❌
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                                {errors.activity && (
                                    <span className="error-message font-size-text">
                                        {errors.activity}
                                    </span>
                                )}
                            </div>

                            {/* Submit */}
                            <div className="button-models" style={{ width: "100%" }}>
                                <button
                                    onClick={handleFormSubmit}
                                    className="model-button font-weight500 model-button-submit"
                                >
                                    {formData.id ? "Update" : "Add"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeletDepartmentAndActivity = ({ i, getDevisionName }) => {
    const [show, setShow] = useState(false);

    const handleShow = () =>{
        setShow(true)
    }

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/detail-design/division/${i.id}/`
            );

            if (res.status === 200) {
                toast.success(`${i.division_name} deleted successfully`);
                await getDevisionName(); // refresh table
                setShow(false);
            }
        } catch (err) {
            toast.error("Failed to delete division");
            console.error(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
             <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Division: {i.division_name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete{" "}
                        <strong>{i.division_name}</strong>?
                    </p>
                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};




const DepartmentSettings = () => {
    // const [mainData, SetMainData] = useState([]);
    const [teamname, setteamname] = useState();

    // const [originalmainData, SetOriginalMainData] = useState([]);
    const [employeename, SetEmployeeName] = useState("");




    const [devision, setDevision] = useState([]);

    const getDevisionName = async () => {
        try {
            const result = await axios.get(`${BASE_URL}/detail-design/division/`);
            setDevision(result.data);
        } catch (err) {
            console.error("Error fetching divisions:", err);
        }
    };


   

    useEffect(() => {
        // applyFilters();
        getDevisionName()
    }, []);


    return (
        <>


            <div className="content-tabs">
                <div className="attendance-box">
                    <div className="attendance-subcont-01">
                        <div className="field-cont">
                           
                        </div>



                        <div className='btn-cont'>
                            <AddDepartmentAndActivity getDevisionName={getDevisionName} />
                        </div>
                    </div>
                    <div className="datagrid-container">
                        <div className="table-css-white-background table-box paddingTop-0px scroll-container-table">
                            <div className="table-heading-flex  field-cont-between table-css-white-background">


                            </div>
                            <table className="table-css">
                                <thead className="table-heading">
                                    <tr className="custom-table-head-tr">
                                        <th className="table-heading-text">
                                            Sr no.
                                        </th>

                                        <th className="align-center table-heading-text">
                                            Division Code
                                        </th>

                                        <th className="align-center table-heading-text" style={{width:"28%"}}>
                                            Division Name
                                        </th>

                                        <th className="align-center table-heading-text" style={{ textAlign: "left", wedth:"15%" }}>
                                            Activity
                                        </th>
                                        <th className="align-right ">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {devision.map((i, index) => (
                                        <React.Fragment key={index}>

                                            <tr className="custom-table-head-td">
                                                <td className="table-body">
                                                    {index + 1}
                                                </td>

                                                <td className="align-center table-body">
                                                    {i.division_code}
                                                </td>
                                                <td className="align-center table-body" style={{width:"28%"}}>
                                                    {i.division_name}
                                                </td>
                                                <td className="align-center table-body" style={{width:"15%"}}>
                                                    {Array.isArray(i.activity) ? (
                                                        <ul style={{ marginleft: "20px", paddingLeft: "0px", listStyle: "none", textAlign: "left" }}>
                                                            {i.activity.map((act, idx) => (
                                                                <li key={idx}>{act}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        i.activity
                                                    )}
                                                </td>

                                                <td className="align-right ">
                                                    <UpdateDepartmentAndActivity
                                                     getDevisionName={getDevisionName} 
                                                     divisionData={i} 
                                                     />

                                                     <DeletDepartmentAndActivity
                                                      i={i} 
                                                     getDevisionName={getDevisionName}
                                                     />
                                                  
                                                </td>

                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const SubCompanymain = () => {

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return "Sub Company";
            case 2:
                return "Structure Heading";
            case 3:
                return "Review Team";
            case 4:
                return "Division";
            default:
                return "Sub Company";
        }
    };
    return (
        <>
            {/* modification required on navbar */}
            <Dashboardnavbar url="Sub Company" name={getSelectedTitle()} />
            <div className="content-tabs ">
                <div
                    className="toggle-button-area flex-row justify-between"
                    style={{ padding: "15px 30px" }}
                >
                    <div>
                        <button
                            className={
                                toggleState === 1
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(1)}
                        >
                            Sub Company
                        </button>

                        {/* <button
                            className={
                                toggleState === 2
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(2)}
                        >
                            Structure Heading
                        </button> */}

                        {/* <button
                            className={
                                toggleState === 3
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(3)}
                        >
                            Team
                        </button> */}
                        
                    </div>
                    {/* 
                    <div className="flex-row justify-end">
                        {toggleState === 1 ? (
                            <TableDesignssubcompany />
                        ) : (
                            <></>
                        )}
                    </div> */}
                </div>
            </div>
            <>
                {toggleState === 1 ? <TableDesignssubcompany /> : null}
                {toggleState === 2 ? <Structureheadingmain /> : null}
                {toggleState === 3 ? <TableReview /> : null}
                {/* {toggleState === 4 ? <DepartmentSettings /> : null} */}
            </>

        </>
    );
};



export default SubCompanymain